<template>
<div>
  <div class="o-layout__row u-margin-bottom">
    <div class="o-layout__col-m-9">
      <h1>{{ header }}</h1>
      <h2 class="h2--secondary">{{ subheader }}</h2>
      <nn-notification
        v-if="error"
        type="error"
        class="u-margin-bottom"
      >{{ error }}
      </nn-notification>
      <slot name="paragraph"></slot>
    </div>
  </div>
  <div class="o-layout__row u-margin-bottom">
    <div class="o-layout__col-m-6">
      <div class="u-color-background--ultra-light-grey">
        <slot />
      </div>
    </div>
  </div>
  <nn-button variant="secondary" @click="cancel" data-test="backHome">Annuleren</nn-button>
</div>
</template>

<script>
export default {
  name: 'resetPasswordContent',
  props: {
    header: String,
    subheader: String,
    error: String,
  },
  methods: {
    cancel () {
      this.$router.push({ name: 'Home' });
    },
  },
};
</script>
